import { useTheme } from "@mui/material/styles";

import Image from "../../Image/Image";

export const ChatbotPlaceholder = () => {
  const theme = useTheme();
  return (
    <div
      style={{
        position: "fixed",
        zIndex: theme.zIndex.hubspot,
        bottom: 0,
        right: 0,
        width: 100,
        height: 96,
      }}
    >
      <Image
        width={60}
        height={60}
        src="/images/chatbot.png"
        alt="Chatbot"
        style={{ marginBottom: 16, marginRight: 16, marginTop: 20, marginLeft: 24, cursor: "pointer" }}
      />
    </div>
  );
};
